import styled from 'styled-components';
// *** Components ***
export const ThemeModeSwitcher = styled.div ``;
//# sourceMappingURL=theme-mode-switcher.styles.js.map